import React from 'react'
import { Skeleton, Collapse, Typography } from 'antd'

import { useCaseViewContext } from '../../context'
import { SectionHeader } from '../SectionHeader'
import { Container } from '../../Styles'

const { Text } = Typography
const { Panel } = Collapse


export const Eligibility = () => {
  const { caseDetails } = useCaseViewContext()

  if (!Array.isArray(caseDetails?.eligibilities) || !caseDetails.eligibilities.length) {
    return null
  }

  return (
    <Container>
      <SectionHeader title="Eligibility" />
      <Skeleton loading={!caseDetails} paragraph={{ rows: 6 }}>
        <Collapse>
          {caseDetails.eligibilities.map(({ 
            ineligibleReasonsGrouped, 
            eligibleReasonsGrouped, 
            warningReasonsGrouped, 
            matrix, 
            applicable 
          }, index) => {
            if (!applicable) {
              return (
                <Panel 
                  key={`${matrix}-${index}`}
                  showArrow={false}
                  header={<Text strong>{matrix}: Not Applicable</Text>}
                />
              )
            }

            return (
              <Panel 
                key={`${matrix}-${index}`}
                showArrow={false}
                header={<Text strong>{matrix}</Text>}
              >
                {Object.entries(eligibleReasonsGrouped || {}).map(([attribute, reasons]) => (
                  <Panel 
                    showArrow={false} 
                    key={`eligible-${attribute}`} 
                    header={
                      <>
                        <Text strong style={{ color: '#52c41a' }}>Eligible</Text>
                        <Text strong> for {attribute}</Text>
                      </>
                    }
                  >
                    <Collapse activeKey={reasons.map((reason, i) => `${reason.question}-${i}`)}>
                      {reasons.map((reason, i) => (
                        <Panel 
                          showArrow={false} 
                          key={`${reason.question}-${i}`} 
                          header={<Text strong>{reason.question}</Text>}
                        >
                          <Text strong style={{ color: '#52c41a' }}>{reason.answer}</Text>
                        </Panel>
                      ))}
                    </Collapse>
                  </Panel>
                ))}

                {Object.entries(warningReasonsGrouped || {}).map(([attribute, reasons]) => (
                  <Panel 
                    showArrow={false} 
                    key={`warning-${attribute}`} 
                    header={
                      <>
                        <Text strong type="warning">Warning</Text>
                        <Text strong> for {attribute}</Text>
                      </>
                    }
                  >
                    <Collapse activeKey={reasons.map((reason, i) => `${reason.question}-${i}`)}>
                      {reasons.map((reason, i) => (
                        <Panel 
                          showArrow={false} 
                          key={`${reason.question}-${i}`} 
                          header={<Text strong>{reason.question}</Text>}
                        >
                          <Text strong type="warning">{reason.answer}</Text>
                        </Panel>
                      ))}
                    </Collapse>
                  </Panel>
                ))}

                {Object.entries(ineligibleReasonsGrouped || {}).map(([attribute, reasons]) => (
                  <Panel 
                    showArrow={false} 
                    key={`ineligible-${attribute}`} 
                    header={
                      <>
                        <Text strong type="danger">Ineligible</Text>
                        <Text strong> for {attribute}</Text>
                      </>
                    }
                  >
                    <Collapse activeKey={reasons.map((reason, i) => `${reason.question}-${i}`)}>
                      {reasons.map((reason, i) => (
                        <Panel 
                          showArrow={false} 
                          key={`${reason.question}-${i}`} 
                          header={<Text strong>{reason.question}</Text>}
                        >
                          <Text strong type="danger">{reason.answer}</Text>
                        </Panel>
                      ))}
                    </Collapse>
                  </Panel>
                ))}
              </Panel>
            )
          })}
        </Collapse>
      </Skeleton>
    </Container>
  )
}